import { render, staticRenderFns } from "./Limited.vue?vue&type=template&id=0cf2c9d1&"
import script from "./Limited.vue?vue&type=script&lang=js&"
export * from "./Limited.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports